import React from 'react';
import { createUseStyles, clsx } from '@pushpay/styles';
import { useColumns } from './columns-context';
export const columnWidths = ['auto', 'content', '4/5', '3/4', '2/3', '3/5', '1/2', '2/5', '1/3', '1/4', '1/5'];

function widthStyles(width) {
  if (width === 'auto') {
    return {
      width: '100%'
    };
  }

  if (width === 'content') {
    return {
      flexShrink: 0
    };
  }

  const [numerator, denominator] = width.split('/');
  const widthPercentage = `${Number(numerator) / Number(denominator) * 100}%`;
  return {
    width: '100%',
    maxWidth: widthPercentage,
    flex: `0 0 ${widthPercentage}`
  };
}

const useStyles = createUseStyles(theme => ({
  root: {},
  row: ({
    width
  }) => ({ ...widthStyles(width)
  }),
  stack: ({
    space
  }) => ({
    marginTop: theme.SPACING[space],
    width: '100%'
  }),
  inner: ({
    space
  }) => ({
    height: '100%',
    paddingLeft: theme.SPACING[space]
  })
}));
export const Column = ({
  classes: classesProp,
  className: classNameProp,
  width = 'auto',
  children,
  ...rest
}) => {
  const {
    stack,
    space
  } = useColumns();
  const classes = useStyles(classesProp, {
    space,
    width
  });
  const className = clsx(classNameProp, classes.root, stack ? classes.stack : classes.row);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: classes.inner
  }, children));
};